import {useSelector} from "react-redux";

export const useSelectChatInfo = (chatId) => {
  return useSelector(({chats}) => ({
    chat: chats.chats[chatId] ?? null,
    activeChatId: chats.activeChatId,
  }));
}
